module.exports = __webpack_public_path__ + "media/backgrounds/gray-target-a898e64d.svg";